var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/html.js
// module id = N5RP
// module chunks = 0